import { toString, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { useProjectStatsBreakdownLabel, useProjectStatsBreakdownEntity, BreakDownByEntity__ToProperString } from "./Data.fs.js";
import { cons, empty as empty_1, choose, map, sortBy as sortBy_1, sortByDescending, filter, singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { equals, comparePrimitives, compare, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { NoData, LoadingBar } from "../Assets.fs.js";
import { interpolate, toText, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { InfoPanel, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F, SearchParams } from "../ClientTypes.fs.js";
import { map as map_2, empty, singleton as singleton_1, append, delay as delay_1, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { System_DateTimeOffset__DateTimeOffset_ToLocaleDateString, System_Int32__Int32_ToLocaleString, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString } from "../Prelude.fs.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { useFeliz_React__React_useDashboardCategory_Static } from "../hooks/UseRouter.fs.js";
import { useFeliz_React__React_useFetch_Static_6ADA66EC, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { labels } from "../Api/Activities.fs.js";
import { defaultArg, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { EPM_Domain_Events_Action_Category__Category_ToUrlString } from "../Api/../Prelude.fs.js";
import { SelectOption, SelectItem, selectSearch_options_113CE11B, selectSearch_filterOptions_Z7A2530AD } from "../fable_modules/Feliz.SelectSearch.3.1.0/SelectSearch.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.SelectSearch.3.1.0/../Feliz.2.9.0/Interop.fs.js";
import react_select_search from "react-select-search";
import { Interop_defaultProps } from "../fable_modules/Feliz.SelectSearch.3.1.0/./SelectSearch.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { Impl_createRemoveOptions, Impl_adjustPassive, Impl_defaultPassive } from "../fable_modules/Feliz.Listeners.1.1.0/./Listener.fs.js";
import { useEffect } from "../fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { createDisposable, useCallbackRef } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { useFeliz_React__React_useDebouncer_Static } from "../hooks/UseDebouncer.fs.js";

class BreakdownBy extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Entity", "Label"];
    }
}

function BreakdownBy_$reflection() {
    return union_type("EPM.App.Dashboard.Breakdown.BreakdownBy", [], BreakdownBy, () => [[["Item", string_type]], []]);
}

function BreakdownBy__ToPropertString(this$) {
    if (this$.tag === 0) {
        return BreakDownByEntity__ToProperString(this$.fields[0]);
    }
    else {
        return "Label";
    }
}

class SortDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ascending", "Descending"];
    }
}

function SortDirection_$reflection() {
    return union_type("EPM.App.Dashboard.Breakdown.SortDirection", [], SortDirection, () => [[], []]);
}

class SortBy extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Date", "Name"];
    }
}

function SortBy_$reflection() {
    return union_type("EPM.App.Dashboard.Breakdown.SortBy", [], SortBy, () => [[["Item", SortDirection_$reflection()]], [["Item", SortDirection_$reflection()]]]);
}

const AllBreakDowns = ofArray([new BreakdownBy(0, ["productionUnit"]), new BreakdownBy(0, ["system"]), new BreakdownBy(0, ["subsystem"]), new BreakdownBy(0, ["facility"]), new BreakdownBy(0, ["module"]), new BreakdownBy(0, ["area"]), new BreakdownBy(0, ["location"]), new BreakdownBy(0, ["discipline"]), new BreakdownBy(0, ["equipmentType"]), new BreakdownBy(1, [])]);

function BreakdownLoading() {
    const elms_1 = ofArray([createElement("div", {
        className: "message-header",
        children: reactApi.Children.toArray(["Breakdown: Loading..."]),
    }), createElement("div", createObj(Helpers_combineClasses("message-body", singleton(["children", createElement("div", {
        children: LoadingBar([]),
    })]))))]);
    return createElement("article", {
        className: "message",
        children: reactApi.Children.toArray(Array.from(elms_1)),
    });
}

function BreakdownNoData(breakdownNoDataInputProps) {
    const dropdown = breakdownNoDataInputProps.dropdown;
    const elms_1 = ofArray([createElement("div", {
        className: "message-header",
        children: reactApi.Children.toArray(["Breakdown: No Data", dropdown]),
    }), createElement("div", createObj(Helpers_combineClasses("message-body", singleton(["children", createElement("div", {
        className: "missing-data",
        children: NoData([]),
    })]))))]);
    return createElement("article", {
        className: "message",
        children: reactApi.Children.toArray(Array.from(elms_1)),
    });
}

function sortEntityData(sortBy, search, data) {
    const searchLower = search.toLocaleLowerCase();
    const data_1 = isNullOrWhiteSpace(search) ? data : filter((d) => (d.EntityName.toLocaleLowerCase().indexOf(searchLower) >= 0), data);
    if (sortBy.tag === 0) {
        if (sortBy.fields[0].tag === 1) {
            return sortByDescending((d_4) => d_4.PlannedDate, data_1, {
                Compare: compare,
            });
        }
        else {
            return sortBy_1((d_3) => d_3.PlannedDate, data_1, {
                Compare: compare,
            });
        }
    }
    else if (sortBy.fields[0].tag === 1) {
        return sortByDescending((d_2) => d_2.EntityName, data_1, {
            Compare: comparePrimitives,
        });
    }
    else {
        return sortBy_1((d_1) => d_1.EntityName, data_1, {
            Compare: comparePrimitives,
        });
    }
}

function sortLabelData(sortBy, search, data) {
    const searchLower = search.toLocaleLowerCase();
    const data_1 = isNullOrWhiteSpace(search) ? data : filter((d) => (d.LabelValue.toLocaleLowerCase().indexOf(searchLower) >= 0), data);
    if (sortBy.tag === 0) {
        if (sortBy.fields[0].tag === 1) {
            return sortByDescending((d_4) => d_4.PlannedDate, data_1, {
                Compare: compare,
            });
        }
        else {
            return sortBy_1((d_3) => d_3.PlannedDate, data_1, {
                Compare: compare,
            });
        }
    }
    else if (sortBy.fields[0].tag === 1) {
        return sortByDescending((d_2) => d_2.LabelValue, data_1, {
            Compare: comparePrimitives,
        });
    }
    else {
        return sortBy_1((d_1) => d_1.LabelValue, data_1, {
            Compare: comparePrimitives,
        });
    }
}

function BreakdownByEntity(breakdownByEntityInputProps) {
    let elms, children_3, children_1;
    const dropdown = breakdownByEntityInputProps.dropdown;
    const search = breakdownByEntityInputProps.search;
    const sortBy = breakdownByEntityInputProps.sortBy;
    const entity = breakdownByEntityInputProps.entity;
    const projectId = breakdownByEntityInputProps.projectId;
    const dataFetch = useProjectStatsBreakdownEntity(projectId, entity);
    switch (dataFetch.tag) {
        case 1:
            return createElement(BreakdownLoading, null);
        case 3:
            return createElement(BreakdownNoData, {
                dropdown: dropdown,
            });
        case 2: {
            const patternInput = (entity === "discipline") ? [new DomainEntities(4, []), undefined] : ((entity === "equipmentType") ? [new DomainEntities(10, []), undefined] : ((entity === "facility") ? [new DomainEntities(3, []), new DomainEntities(3, [])] : ((entity === "location") ? [new DomainEntities(8, []), new DomainEntities(8, [])] : ((entity === "module") ? [new DomainEntities(6, []), new DomainEntities(6, [])] : ((entity === "productionUnit") ? [new DomainEntities(13, []), new DomainEntities(13, [])] : ((entity === "subsystem") ? [new DomainEntities(2, []), new DomainEntities(2, [])] : ((entity === "system") ? [new DomainEntities(1, []), new DomainEntities(1, [])] : [new DomainEntities(7, []), new DomainEntities(7, [])])))))));
            const elms_1 = ofArray([(elms = ofArray([`Breakdown By ${BreakDownByEntity__ToProperString(entity)}`, dropdown]), createElement("div", {
                className: "message-header",
                children: reactApi.Children.toArray(Array.from(elms)),
            })), (children_3 = singleton((children_1 = map((d) => {
                let elems_5, elems_3, elems_4;
                const percent = (d.Total > 0) ? 0 : ((d.Completed / d.Total) * 100);
                const newParams = singleton(new SearchParams(2, [d.EntityId, patternInput[0]]));
                return createElement("li", createObj(ofArray([["key", d.EntityId], (elems_5 = [createElement("div", createObj(ofArray([["className", "progress-info"], (elems_3 = toList(delay_1(() => {
                    let elems_1;
                    return append(singleton_1(createElement("div", createObj(ofArray([["className", "name"], (elems_1 = [createElement("a", {
                        className: "has-text-link",
                        href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(newParams, false),
                        onClick: (e) => {
                            e.preventDefault();
                            Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(newParams, false);
                        },
                        children: d.EntityName,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay_1(() => {
                        let elems_2;
                        const matchValue = patternInput[1];
                        if (matchValue != null) {
                            const entityType = matchValue;
                            return singleton_1(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-clickable"], ["className", "has-text-warning"], ["title", `InfoPanel for ${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(entityType)} ${d.EntityName}`], ["onClick", (_arg) => {
                                Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(new SearchParams(4, [new InfoPanel(1, [d.EntityId, entityType])])), false);
                            }], ["className", "is-small"], (elems_2 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-info-circle"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))));
                        }
                        else {
                            return singleton_1(defaultOf());
                        }
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", {
                    className: "progress-bar",
                    children: createElement("progress", createObj(Helpers_combineClasses("progress", toList(delay_1(() => append(singleton_1(["className", "is-small"]), delay_1(() => append((d.Behind > 0) ? singleton_1(["className", "is-danger"]) : (((d.Total > 0) && (d.Completed === d.Total)) ? singleton_1(["className", "is-success"]) : singleton_1(["className", "is-primary"])), delay_1(() => append(singleton_1(["value", d.Completed]), delay_1(() => append(singleton_1(["max", d.Total]), delay_1(() => singleton_1(["title", toText(interpolate("%.2f%P()%%", [percent]))])))))))))))))),
                }), createElement("div", createObj(ofArray([op_PlusPlus(["className", "progress-info"], ["className", "is-size-7"]), (elems_4 = toList(delay_1(() => append(singleton_1(createElement("span", {
                    children: [`${System_Int32__Int32_ToLocaleString(d.Completed)} / ${System_Int32__Int32_ToLocaleString(d.Total)}`],
                })), delay_1(() => {
                    const matchValue_1 = d.PlannedDate;
                    if (matchValue_1 != null) {
                        const date = matchValue_1;
                        return singleton_1(createElement("time", {
                            dateTime: toString(date),
                            children: System_DateTimeOffset__DateTimeOffset_ToLocaleDateString(date),
                        }));
                    }
                    else {
                        return singleton_1(defaultOf());
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
            }, sortEntityData(sortBy, search, dataFetch.fields[0])), createElement("ul", {
                children: reactApi.Children.toArray(Array.from(children_1)),
            }))), createElement("div", {
                className: "message-body",
                children: reactApi.Children.toArray(Array.from(children_3)),
            }))]);
            return createElement("article", {
                className: "message",
                children: reactApi.Children.toArray(Array.from(elms_1)),
            });
        }
        default:
            return createElement(BreakdownLoading, null);
    }
}

function BreakdownByLabel(breakdownByLabelInputProps) {
    let inputProperties, elms_4, children_4;
    const dropdown = breakdownByLabelInputProps.dropdown;
    const search = breakdownByLabelInputProps.search;
    const sortBy = breakdownByLabelInputProps.sortBy;
    const projectId = breakdownByLabelInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setLabel = patternInput[1];
    const labelOpt = patternInput[0];
    const dataFetch = useProjectStatsBreakdownLabel(projectId, labelOpt);
    const categoryOpt = useFeliz_React__React_useDashboardCategory_Static();
    const fetchedLabelsOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((activityParams) => labels(projectId, activityParams), choose((x) => x, singleton(map_1((category) => ["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(category)], categoryOpt))), [projectId, categoryOpt]));
    let labelDropDown;
    if (fetchedLabelsOpt != null) {
        const fetchedLabels = fetchedLabelsOpt;
        labelDropDown = createElement("div", {
            className: "mb-3",
            children: (inputProperties = createObj(toList(delay_1(() => append(singleton_1(["placeholder", "Select Label"]), delay_1(() => {
                let matchValue;
                return append((matchValue = labelOpt, (matchValue == null) ? (empty()) : singleton_1(["value", matchValue])), delay_1(() => append(singleton_1(["search", true]), delay_1(() => append(singleton_1(["closeOnSelect", false]), delay_1(() => append(singleton_1(["printOptions", "on-focus"]), delay_1(() => append(singleton_1(selectSearch_filterOptions_Z7A2530AD((item, searchQuery) => (item.value.toLocaleLowerCase().indexOf(searchQuery.trim().toLocaleLowerCase()) >= 0))), delay_1(() => append(singleton_1(["onChange", (chosenLabel) => {
                    if (chosenLabel === "") {
                        setLabel(undefined);
                    }
                    else {
                        setLabel(chosenLabel);
                    }
                }]), delay_1(() => singleton_1(selectSearch_options_113CE11B(toList(delay_1(() => append(singleton_1(new SelectOption(0, [new SelectItem("", "--- No Label Selected ---", false)])), delay_1(() => map_2((label_1) => (new SelectOption(0, [new SelectItem(label_1[0], label_1[0], false)])), fetchedLabels)))))))))))))))))));
            }))))), reactApi_1.createElement(react_select_search, Object.assign({}, Interop_defaultProps, inputProperties))),
        });
    }
    else {
        labelDropDown = defaultOf();
    }
    switch (dataFetch.tag) {
        case 1:
            return createElement(BreakdownLoading, null);
        case 3:
            return createElement(BreakdownNoData, {
                dropdown: dropdown,
            });
        case 2: {
            const elms_5 = ofArray([createElement("div", {
                className: "message-header",
                children: reactApi.Children.toArray(["Breakdown By Label", dropdown]),
            }), (elms_4 = ofArray([labelDropDown, (children_4 = map((d) => {
                let elems_6, elems_4, elems_5;
                const percent = (d.Total > 0) ? 0 : ((d.Completed / d.Total) * 100);
                const newParams = (labelOpt != null) ? singleton(new SearchParams(5, [new DomainEntities(5, []), ofList(singleton([labelOpt, ofList_1(singleton(d.LabelValue), {
                    Compare: comparePrimitives,
                })]), {
                    Compare: comparePrimitives,
                })])) : empty_1();
                return createElement("li", createObj(ofArray([["key", d.LabelValue], (elems_6 = [createElement("div", createObj(ofArray([["className", "name"], (elems_4 = [createElement("a", {
                    href: Feliz_Router_Router__Router_formatQueryPath_Static_6F3B930F(newParams, false),
                    className: "has-text-link",
                    onClick: (e) => {
                        e.preventDefault();
                        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(newParams, false);
                    },
                    children: d.LabelValue,
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", {
                    className: "progress-bar",
                    children: createElement("progress", createObj(Helpers_combineClasses("progress", toList(delay_1(() => append(singleton_1(["className", "is-small"]), delay_1(() => append((d.Behind > 0) ? singleton_1(["className", "is-danger"]) : (((d.Total > 0) && (d.Completed === d.Total)) ? singleton_1(["className", "is-success"]) : singleton_1(["className", "is-primary"])), delay_1(() => append(singleton_1(["value", d.Completed]), delay_1(() => append(singleton_1(["max", d.Total]), delay_1(() => singleton_1(["title", toText(interpolate("%.2f%P()%%", [percent]))])))))))))))))),
                }), createElement("div", createObj(ofArray([op_PlusPlus(["className", "progress-info"], ["className", "is-size-7"]), (elems_5 = toList(delay_1(() => append(singleton_1(createElement("span", {
                    children: [`${System_Int32__Int32_ToLocaleString(d.Completed)} / ${System_Int32__Int32_ToLocaleString(d.Total)}`],
                })), delay_1(() => {
                    const matchValue_1 = d.PlannedDate;
                    if (matchValue_1 != null) {
                        const date = matchValue_1;
                        return singleton_1(createElement("time", {
                            dateTime: toString(date),
                            children: System_DateTimeOffset__DateTimeOffset_ToLocaleDateString(date),
                        }));
                    }
                    else {
                        return singleton_1(defaultOf());
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
            }, sortLabelData(sortBy, search, dataFetch.fields[0])), createElement("ul", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            }))]), createElement("div", {
                className: "message-body",
                children: reactApi.Children.toArray(Array.from(elms_4)),
            }))]);
            return createElement("article", {
                className: "message",
                children: reactApi.Children.toArray(Array.from(elms_5)),
            });
        }
        default: {
            const elms_2 = ofArray([createElement("div", {
                className: "message-header",
                children: reactApi.Children.toArray(["Breakdown By Label", dropdown]),
            }), createElement("div", {
                className: "message-body",
                children: reactApi.Children.toArray([labelDropDown]),
            })]);
            return createElement("article", {
                className: "message",
                children: reactApi.Children.toArray(Array.from(elms_2)),
            });
        }
    }
}

function breakdownItem(currentType, setType, breakdownType) {
    return createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append(singleton_1(["onClick", (e) => {
        e.preventDefault();
        setType(breakdownType);
    }]), delay_1(() => append(singleton_1(["children", BreakdownBy__ToPropertString(breakdownType)]), delay_1(() => (equals(breakdownType, currentType) ? singleton_1(["className", "is-active"]) : empty()))))))))));
}

function BreakdownType(breakdownTypeInputProps) {
    const setType = breakdownTypeInputProps.setType;
    const currentType = breakdownTypeInputProps.currentType;
    const patternInput = reactApi.useState(false);
    const showMenu = patternInput[0];
    const setShowMenu = patternInput[1];
    const ref = reactApi.useRef(undefined);
    const elemRef = ref;
    const callback = reactApi.useCallback((_arg) => {
        setShowMenu(false);
    }, []);
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_1 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_1);
    let removeOptions;
    const dependencies_1_2 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_2);
    let fn;
    const dependencies_1_3 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_3);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_4 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_4);
    let removeOptions_1;
    const dependencies_1_5 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_5);
    let fn_1;
    const dependencies_1_6 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_6);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    return createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay_1(() => append(singleton_1(["ref", ref]), delay_1(() => append(singleton_1(["className", "is-right"]), delay_1(() => append(showMenu ? singleton_1(["className", "is-active"]) : empty(), delay_1(() => {
        let elems_3, elms, elems, elms_1;
        return singleton_1((elems_3 = [(elms = singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["onClick", (_arg_1) => {
            setShowMenu(!showMenu);
        }], ["className", "is-small"], (elems = [Fa_i(toList(delay_1(() => (showMenu ? singleton_1(new Fa_IconOption(11, ["fas fa-chevron-up"])) : singleton_1(new Fa_IconOption(11, ["fas fa-chevron-down"]))))), [])], ["children", reactApi.Children.toArray(Array.from(elems))])]))))), createElement("div", {
            className: "dropdown-trigger",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton(["children", (elms_1 = map((breakdownType) => breakdownItem(currentType, setType, breakdownType), AllBreakDowns), createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
    })))))))))));
}

function BreakdownHeader(breakdownHeaderInputProps) {
    let elems_6;
    const setSearch = breakdownHeaderInputProps.setSearch;
    const setSort = breakdownHeaderInputProps.setSort;
    const currentSort = breakdownHeaderInputProps.currentSort;
    const setType = breakdownHeaderInputProps.setType;
    const currentType = breakdownHeaderInputProps.currentType;
    const patternInput = useFeliz_React__React_useDebouncer_Static("", setSearch, 300);
    return createElement("div", createObj(ofArray([["className", "breakdown-header"], (elems_6 = [createElement("span", {
        className: "mr-2",
        children: createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", ofArray([["className", "is-small"], ["onChange", (ev) => {
            patternInput[1](ev.target.value);
        }], ["value", patternInput[0]]]))))),
    }), createElement("span", createObj(Helpers_combineClasses("icon", toList(delay_1(() => append(singleton_1(op_PlusPlus(["className", "is-clickable"], ["className", "mr-2"])), delay_1(() => {
        const matchValue = currentSort;
        return (matchValue.tag === 0) ? ((matchValue.fields[0].tag === 1) ? append(singleton_1(["onClick", (_arg_2) => {
            setSort(new SortBy(0, [new SortDirection(0, [])]));
        }]), delay_1(() => append(singleton_1(["title", "Sort By Date Descending"]), delay_1(() => {
            let elems_2;
            return singleton_1((elems_2 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sort-amount-down"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_2))]));
        })))) : append(singleton_1(["onClick", (_arg_1) => {
            setSort(new SortBy(0, [new SortDirection(1, [])]));
        }]), delay_1(() => append(singleton_1(["title", "Sort By Date Ascending"]), delay_1(() => {
            let elems_1;
            return singleton_1((elems_1 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sort-amount-up-alt"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
        }))))) : append(singleton_1(op_PlusPlus(["className", "has-text-grey"], ["className", "mr-2"])), delay_1(() => append(singleton_1(["onClick", (_arg) => {
            setSort(new SortBy(0, [new SortDirection(0, [])]));
        }]), delay_1(() => append(singleton_1(["title", "Sort By Date Ascending"]), delay_1(() => {
            let elems;
            return singleton_1((elems = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sort-amount-up-alt"])), [])], ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))));
    }))))))), createElement("span", createObj(Helpers_combineClasses("icon", toList(delay_1(() => append(singleton_1(op_PlusPlus(["className", "is-clickable"], ["className", "mr-2"])), delay_1(() => {
        const matchValue_2 = currentSort;
        return (matchValue_2.tag === 1) ? ((matchValue_2.fields[0].tag === 1) ? append(singleton_1(["onClick", (_arg_5) => {
            setSort(new SortBy(1, [new SortDirection(0, [])]));
        }]), delay_1(() => append(singleton_1(["title", "Sort By Name Descending"]), delay_1(() => {
            let elems_5;
            return singleton_1((elems_5 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sort-alpha-down-alt"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_5))]));
        })))) : append(singleton_1(["onClick", (_arg_4) => {
            setSort(new SortBy(1, [new SortDirection(1, [])]));
        }]), delay_1(() => append(singleton_1(["title", "Sort By Name Ascending"]), delay_1(() => {
            let elems_4;
            return singleton_1((elems_4 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sort-alpha-up"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_4))]));
        }))))) : append(singleton_1(op_PlusPlus(["className", "has-text-grey"], ["className", "mr-2"])), delay_1(() => append(singleton_1(["onClick", (_arg_3) => {
            setSort(new SortBy(1, [new SortDirection(0, [])]));
        }]), delay_1(() => append(singleton_1(["title", "Sort By Name Ascending"]), delay_1(() => {
            let elems_3;
            return singleton_1((elems_3 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sort-alpha-up"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
        }))))));
    }))))))), createElement(BreakdownType, {
        currentType: currentType,
        setType: setType,
    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function Breakdown(breakdownInputProps) {
    const projectId = breakdownInputProps.projectId;
    const patternInput = reactApi.useState(new BreakdownBy(0, ["system"]));
    const breakdownBy = patternInput[0];
    const patternInput_1 = reactApi.useState(new SortBy(1, [new SortDirection(0, [])]));
    const sortBy = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const search = patternInput_2[0];
    const dropdown = createElement(BreakdownHeader, {
        currentType: breakdownBy,
        setType: patternInput[1],
        currentSort: sortBy,
        setSort: patternInput_1[1],
        setSearch: patternInput_2[1],
    });
    return createElement("div", createObj(Helpers_combineClasses("tile", ofArray([["className", "is-child"], ["children", (breakdownBy.tag === 1) ? createElement(BreakdownByLabel, {
        projectId: projectId,
        sortBy: sortBy,
        search: search,
        dropdown: dropdown,
    }) : createElement(BreakdownByEntity, {
        projectId: projectId,
        entity: breakdownBy.fields[0],
        sortBy: sortBy,
        search: search,
        dropdown: dropdown,
    })]]))));
}

